export default __webpack_public_path__ + "static/media/daph.a15d974a.png";